import { TreeNode } from '../types';

/**
 * Получает состояние чекбокса родителя
 * @param item элемент дерева, у родителя которого нужно получить state
 * @param checkboxMap пары id ноды и ее состояния
 * @param initialCheckboxValue начальное состояние дерева (все включены или все выключены)
 * @returns включена родительская галочка или нет
 */
export function getParentCheckboxState({
    item,
    checkboxMap,
    initialCheckboxValue,
}: {
    item: TreeNode;
    checkboxMap: Map<string, boolean>;
    initialCheckboxValue: boolean;
}) {
    let depthLimit = 300;
    let current = item.parent;

    while (current) {
        const parentState = checkboxMap.get(current.id);
        if (parentState !== undefined) {
            return parentState;
        }
        current = current.parent;

        // На всякий случай добавим предохранитель от бесконечных циклов
        if (depthLimit-- <= 0) {
            console.error(new Error('Обнаружен цикл в дереве'));
            return initialCheckboxValue;
        }
    }
    return initialCheckboxValue;
}
